import { render, staticRenderFns } from "./invite-employee.vue?vue&type=template&id=36229d86&"
import script from "./invite-employee.vue?vue&type=script&lang=js&"
export * from "./invite-employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports